import sanitizeHtml from "sanitize-html";
import styled from "styled-components";

const Format = styled.div`
    display:flex;
    row-gap: 10px;
    flex-direction: column;
`;

export default function safeTextToHTML(props) {

    const HtmlFromText = sanitizeHtml (props.text, {
        allowedTags: ['b', 'div', 'h3', 'h4', 'hr', 'i', 'li', 'ol', 'p', 'span', 'strong', 'table', 'td', 'th', 'tr', 'u', 'ul'],
    })

    return(
        <Format dangerouslySetInnerHTML={{__html: HtmlFromText}}/>
    )
}

